import React, { useState, useCallback } from "react"
import { GROUPS, PLACES } from "./constants"
import { groupBy, get, uniqBy } from "lodash"

/**
 * 
 * @param {{ 
 *  state: { 
 *    group: string, 
 *    space: string, 
 *    week: string, 
 *    day: string, 
 *    slice: string 
 *  }[], 
 *  setState: Function 
 * }} props 
 */
const InsertRecordForm = ({ state, onCommit }) => {
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [selectedSpace, setSelectedSpace] = useState(null)
  const [selectedWeek, setSelectedWeek] = useState("1a settimana")
  const [selectedDay, setSelectedDay] = useState("Lunedì")
  const [selectedSlice, setSelectedSlice] = useState("pre")
  const [activity, setActivity] = useState("")

  const sameDateRecords = state
    .filter(item => item.week === selectedWeek && item.day === selectedDay && item.slice === selectedSlice)

  const availableGroups = GROUPS

  const spaceBusiNess = groupBy(sameDateRecords, "space")

  const availableSpaces = PLACES.filter(place => {
    const busy = get(spaceBusiNess, place.name, []).length
    if (busy >= place.capacity) {
      return false
    }
    if (place.incompatible.some(placeName => placeName in spaceBusiNess)) {
      return false
    }
    return true
  }).map(space => space.name)

  const availableSlices = ["pre", "post"]

  const availableWeeks = ["1a settimana", "2a settimana", "3a settimana", "4a settimana"]

  const availableDays = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì"]

  const suggestActivities = uniqBy(state.map(record => record.activity))

  const handleSubmit = useCallback(e => {
    e.preventDefault()
    onCommit({
      group: selectedGroup,
      space: selectedSpace,
      week: selectedWeek,
      day: selectedDay,
      slice: selectedSlice,
      activity: activity
    })
    return false
  }, [activity, onCommit, selectedDay, selectedGroup, selectedSlice, selectedSpace, selectedWeek])

  const infeasible = 
    availableGroups.length === 0 || 
    availableSlices.length === 0 || 
    availableSpaces.length === 0 || 
    availableWeeks.length === 0 || 
    availableDays.length === 0 || 
    activity.length === 0 ||
    state.find(record => record.group === selectedGroup && record.week === selectedWeek && record.day === selectedDay && record.slice === selectedSlice)

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Gruppo
        <select value={selectedGroup || "no"} onChange={e => setSelectedGroup(e.target.value)}>
          <option value="no">Seleziona gruppo</option>
          {availableGroups.map(g => (
            <option key={g} value={g}>{g}</option>
          ))}
        </select>
      </label>

      <label>
        Settimana
        <select value={selectedWeek} onChange={e => setSelectedWeek(e.target.value)}>
          {availableWeeks.map(w => (
            <option key={w} value={w}>{w}</option>
          ))}
        </select>
      </label>

      <label>
        Giorno
        <select value={selectedDay} onChange={e => setSelectedDay(e.target.value)}>
          {availableDays.map(d => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
      </label>

      <label>
        Fascia
        <select value={selectedSlice} onChange={e => setSelectedSlice(e.target.value)}>
          {availableSlices.map(sl => (
            <option key={sl} value={sl}>{sl}</option>
          ))}
        </select>
      </label>

      <label>
        Spazio
        <select value={selectedSpace} onChange={e => setSelectedSpace(e.target.value)}>
          <option value="no">Seleziona spazio</option>
          {availableSpaces.map(place => (
            <option key={place} value={place}>{place}</option>
          ))}
        </select>
      </label>

      <label>
        Attività
        <input type="text" value={activity} onChange={e => setActivity(e.target.value)} list="suggest" />
        <datalist id="suggest">
          {suggestActivities.map(a => (
            <option key={a}>{a}</option>
          ))}
        </datalist>
      </label>

      <button type="submit" className="btn btn-sm btn-primary" disabled={selectedGroup === null || infeasible}>Inserisci</button>
    </form>
  )
}

export default InsertRecordForm